// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1UserSchema = z.object({
  id: z.number().int().gt(0),
  email: z.coerce.string().min(1).regex(new RegExp("^([^@\\s]+)@((?:[-a-z0-9]+\\.)+[a-z]{2,})$")),
  name: z.coerce.string().min(1),
  active: z.boolean(),
  day_view_onboarded: z.boolean(),
  memory_onboarded: z.boolean(),
  created_at: z.number().int().describe("The time represented as a Unix timestamp (epoch) (seconds since January 1, 1970)"),
  updated_at: z.number().int().describe("The time represented as a Unix timestamp (epoch) (seconds since January 1, 1970)"),
  last_received_memories_date: z.nullable(z.string().datetime().describe("ISO8601")),
  sign_in_count: z.nullable(z.number().int()),
  external_id: z.nullable(z.coerce.string().max(512).describe("Can be used to reference external resource IDs to Timely resources")),
  time_zone: z.coerce.string().min(1),
  memory_retention_days: z.nullable(z.number().int()),
  type: z.coerce.string().min(1),
  avatar: z.object({
    large_retina: z.coerce.string().url(),
    large: z.coerce.string().url(),
    medium_retina: z.coerce.string().url(),
    medium: z.coerce.string().url(),
    small_retina: z.coerce.string().url(),
    small: z.coerce.string().url(),
  }),
  work_days: z.optional(z.coerce.string().describe("Coma separated working days. Example: *'SUN,MON,TUE,WED,THU,FRI,SAT'*")),
  weekdays: z.optional(z.coerce.string().describe("Coma separated working days. Example: *'SU,MO,TU,WE,TH,FR,SA'*")),
  weekly_capacity: z.optional(z.number().min(0).describe("Specifies the user's weekly hour capacity. The default is account's weekly capacity. Can only have a decimal place of .5 (e.g. 3.5 hours)")),
  active_projects_count: z.optional(z.number().int().min(0)),
  user_level: z.optional(z.coerce.string().describe("Describes user access level like **admin**, **manager**, **employee** or **team_lead**")),
  admin: z.optional(z.boolean()),
  hide_hourly_rate: z.optional(z.boolean()),
  hide_internal_hourly_rate: z.optional(z.boolean()),
  deleted: z.optional(z.boolean()),
  default_hour_rate: z.optional(z.number().min(0)),
  internal_hour_rate: z.optional(z.number().min(0)),
  role_id: z.optional(z.number().int().gt(0)),
  role: z.optional(z.object({
    id: z.optional(z.number().int().gt(0)),
    name: z.optional(z.coerce.string().describe("Describes user role like **admin**, **manager**, **employee** or **team_lead**")),
  })),
});
